export class tDate {
	m: number;
	y: number;

	constructor(m: number, y: number){
		this.m = m;
		this.y = y;
	}
}